









































	import { VForm } from '@/models/Types';
	import Vue from 'vue';
    import _users from '../../services/endpoints/users';

    export default Vue.extend({
        name: "ProfilePasswordComp",
        data: () => ({
            valid: true,
            oldPassword: '',
            newPassword: '',
            passwordRules: [
                (v: string) => !!v || 'Bitte gib dein Passwort an',
            ],
            buttonColor: '',
            buttonText: 'Passwort aktualisieren'
        }),
        computed: {
            passwordRepeatRules: function(): any {
                return [
                    (v: string) => v === this.newPassword || 'Passwörter müssen übereinstimmen'
                ]
            },
			form: function(): VForm {
				return this.$refs.form as VForm;
			}
        },
        methods: {
            async submit(): Promise<void> {
                if (this.form.validate()) {
                    const response = await _users.changePassword(this.oldPassword, this.newPassword);
                    if (response) {
                        this.buttonText = 'success';
                        this.buttonColor = 'success';
                    } else {
                        this.buttonText = 'Passwort falsch';
                        this.buttonColor = 'error';
                    }
                    // eslint-disable-next-line @typescript-eslint/no-this-alias
                    const that = this;
                    setTimeout(function() {
                        that.buttonColor = '';
                        that.buttonText = 'Passwort aktualisieren';
                    }, 2000)
                }
            },
        }
    })
